import React from 'react'

const About = () => {
  return (
      <div className="block-content">
        <h1 className="title">About Me</h1>
        <p className="subtitle">
          I am a <b>Full Stack Software Engineer</b> located near{' '}
          <b>Amsterdam</b>, the Netherlands.
        </p>
        <p>
          I enjoy working with stakeholders and being at the forefront of
          business and technology to solve challenging problems in creative
          ways. Specialised in the design and implementation of large-scale
          complex systems, I have a lot of experience with full-stack software
          development. I am most effective working within agile
          inter-disciplinary teams and well versed in Agile methodologies like Scrum.
        </p>
        <p>
          I have a no-nonsense personality. My core values are honesty and
          transparency. I communicate directly, but respectfully and with an
          open mind. I enjoy a healthy balance between working from home and on
          location.
        </p>
        <p>
          I try to live a healthy lifestyle with my family. In our free time, we
          enjoy a variety of sports played at a casual level, visiting cultural
          events and playing Mario Kart competitively.
        </p>
      </div>
  )
}

export default About
